export default __webpack_public_path__ + "static/media/cp_geo_gu.63700bdd.svg";